/* eslint-disable no-unused-vars */
export default (theme) => ({
  root: {
    justifyContent: 'flex-end',
    alignItems: 'center',
    display: 'flex',
  },
});
